<template>
  <f7-page>
    <f7-navbar :no-shadow="true">
      <f7-nav-left>
        <a class="link color-theme-white popup-close" href="#">
          <i class="icon icon-back"></i>
          <span>返回</span>
        </a>
      </f7-nav-left>
      <f7-nav-title>{{ title }}</f7-nav-title>
    </f7-navbar>
    <f7-searchbar
      custom-search
      disable-button-text="取消"
      placeholder="请输入姓名"
      @searchbar:search="searchWorkerList">
    </f7-searchbar>
    <div
      class="has-content"
      style="text-align: center;"
      v-if="workerList.length === 0">
      暂无数据
    </div>
    <f7-list
      media-list
      virtual-list
      v-else>
      <f7-list-item v-for="item in workerList" :key="item.id">
        <div slot="inner" class="worker-item">
          <div style="width: 1.35rem; padding-right: 0.5rem;">
            <f7-checkbox
              name="workerId"
              :value="item.id"
              :checked="checkedList.findIndex(c => c.id ===item.id) >= 0"
              @change="checkedWorker">
            </f7-checkbox>
          </div>
          <div class="worker-avatar">
            <img style="width: 2.5rem; height: 2.5rem;"
              :src="imageUrl+'?attachmentId='+item.headImage"
              v-if="item.headImage"/>
            <img style="width: 2.5rem; height: 2.5rem;"
              src="@/assets/img/avatar.png"
              v-else/>
          </div>
          <div class="worker-text">
            <f7-link @click="callUserDetail(item.id)">
              <div style="display: flex; align-items: start;">
                <div style="color: #000000;">{{ item.name }}</div>
                <competitiveness :score="item.score"></competitiveness>
                <!-- <div class="worker-auth" v-if="item.authentication">
                  <span>
                    <f7-icon size="0.8rem" material="verified_user" color="red"></f7-icon>
                  </span>
                  <span>已认证</span>
                </div> -->
              </div>
              <div class="worker-text-sub">
                <f7-row no-gap style="padding: 0.5rem 0rem;">
                  <f7-col>
                    <span class="worker-text-type">
                      {{ (item.positionListDesc || []).join('/') }}&nbsp;
                    </span>
                  </f7-col>
                </f7-row>
                <f7-row no-gap>
                  <f7-col width="25">
                    <span class="worker-text-label">地区</span>
                    <span class="worker-text-value">{{ item.regionDesc || '--' }}</span>
                  </f7-col>
                  <f7-col width="25">
                    <span class="worker-text-label">工龄</span>
                    <span class="worker-text-value">{{ item.workingYears }}</span>
                    <span class="worker-text-label">年</span>
                  </f7-col>
                  <f7-col width="50">
                    <span class="worker-text-label">当前任务</span>
                    <span class="worker-text-value">{{ item.currentTaskCount }}</span>
                  </f7-col>
                </f7-row>
              </div>
            </f7-link>
          </div>
        </div>
        <div slot="content" class="worker-after">
          <div style="width: 3.5rem;">
            <f7-link>
              <span class="worker-phone">
                <f7-icon size="2rem" fa="phone"></f7-icon>
              </span>
            </f7-link>
          </div>
        </div>
      </f7-list-item>
    </f7-list>
  </f7-page>
</template>
<script>

import { toPersonalDetail } from '@/util/native';
import { imageView } from '@/api/common';
import { getManagerList } from '@/api/project/manager';
import lodash from 'lodash';
import Competitiveness from '@/components/Competitiveness';

export default {
  props: ['title', 'opened', 'projectId', 'result'],
  components: {
    Competitiveness,
  },
  data() {
    return {
      name: '',
      imageUrl: imageView,
      workerList: [],
      checkedList: [],
    };
  },
  created() {
    this.debouncedGetList = lodash.debounce(this.getList, 500);
  },
  watch: {
    opened(val) {
      if (val) {
        this.checkedList = lodash.concat([], this.result);
        this.getList();
      }
    },
    name() {
      this.debouncedGetList();
    },
  },
  methods: {
    callUserDetail(id) {
      toPersonalDetail('professional', id);
    },
    checkedWorker(event) {
      const value = event.target.value;
      if (event.target.checked) {
        const obj = this.workerList.find((item => item.id === value));
        if (obj) {
          this.checkedList.push(obj);
        }
      } else {
        const index = this.checkedList.findIndex((item => item.id === value));
        if (index >= 0) {
          this.checkedList.splice(index, 1);
        }
      }
      this.$emit('update:result', this.checkedList);
    },
    getList() {
      const params = {
        projectId: this.projectId,
        name: this.name,
      };
      getManagerList(params).then((result) => {
        if (result.code === 0) {
          this.workerList = result.data || [];
        }
      });
    },
    searchWorkerList(searchbar, query, previousQuery) {
      if (query !== previousQuery) {
        this.name = query;
      }
    },
  },
};
</script>

<style lang="scss" scoped>

  .worker-item {
    font-size: 1rem;
    display: flex;
    align-items: center;
    width: 100%;
  }

  .worker-avatar {
    width: 2.5rem;
    margin-right: 0.5rem;
    text-align: center;
  }

  .worker-text {
    font-size: 1rem;
    width: 100%;
  }

  .worker-auth {
    min-width: 2.5rem;
    margin-right: 0.3rem;
    margin-left: 1rem;
    margin-top: 0.2rem;
    padding: 0rem 0.2rem;
    height: 1rem;
    font-size: 0.8rem;
    border: 0.05rem solid red;
    border-radius: 0.2rem;
  }

  .worker-text-sub {
    font-size: 0.8rem;
  }

  .worker-text-type {
    /* background-color: #EEEEEE;
    border-radius: 0.2rem;
    padding: 0rem 0.2rem; */
    height: 150%;
    color: #999999;
  }

  .worker-text-label {
    color: #999999;
  }

  .worker-text-value {
    color: #FF9403;
  }

  .worker-after {
    display: flex;
    align-items:center;
    justify-content:center;
    margin-left: 0.3rem;
    margin-right: 0.3rem;
    color: #FF9403;
    font-size: 0.6rem;
    text-align: center;
  }

  .worker-phone {
    color: #FF9403;
  }

</style>



// WEBPACK FOOTER //
// src/components/WorkerList.vue